import { useContext } from "react";
import StarekContext from "../context/StarekContext";

// The backend identifies the Owner role by name too — rbacMiddleware
// grantOwnerMembership and Workspace.generateDefaultPlantWithAccess both look
// it up with `role.findFirst({ where: { name: "Owner" } })` — so there is no
// stable id to compare against.
export const OWNER_ROLE_NAME = "Owner";

// True when the signed-in user's membership for the current plant carries the
// Owner role. Ownership is per plant: an owner of one plant may hold a lesser
// role on another.
export function isOwnerOfPlant(memberships, plantId) {
    if (plantId == null) return false;
    const id = Number(plantId);
    // Plant ids round-trip through localStorage, so they may arrive as strings.
    return (memberships || []).some(
        (m) => Number(m.plant_id) === id && m.role?.name === OWNER_ROLE_NAME,
    );
}

export function useIsOwner() {
    const { memberships, lastUsedPlant } = useContext(StarekContext);
    return isOwnerOfPlant(memberships, lastUsedPlant?.id);
}

export default useIsOwner;
